import ApiService from './api.service'
import { TokenService } from './storage.service'
import axios from 'axios'
// axios.defaults.headers.post['Content-Type'] = 'application/json';
class AuthenticationError extends Error {
	constructor (errorCode, message) {
		super(message)
		this.name = this.constructor.name
		this.message = message
		this.errorCode = errorCode
	}
}

const UserService = {
	/**
	 * Login the user and store the access token to TokenService.
	 *
	 * @returns access_token
	 * @throws AuthenticationError
	 **/
	login: async function (userData) {
		const requestData = {
			method: 'post',
			url: '/auth-payload',
			data: {
				username: userData.username,
				password: userData.password
			}
		};

		try {
			const response = await ApiService.customRequest(requestData);
			if(response.data.depCurrencyId) {
				TokenService.saveDepCurrencyId(response.data.depCurrencyId);
			} else {
				TokenService.removeDepCurrencyId();
			}
			if(response.data.depCurrencyCode) {
				TokenService.saveDepCurrencyCode(response.data.depCurrencyCode);
			} else {
				TokenService.removeDepCurrencyCode();
			}
			if(response.data.depCurrencyName) {
				TokenService.saveDepCurrencyName(response.data.depCurrencyName);
			} else {
				TokenService.removeDepCurrencyName();
			}
			TokenService.saveToken(response.data.token);
			TokenService.saveCurrentUserId(response.data.id);
			TokenService.saveDepartmentId(response.data.departmentId);
			TokenService.setDepartmentType(response.data.departmentType);
			TokenService.setDepSaleType(response.data.departmentSaleType);
			TokenService.setUserName(response.data.username);
			TokenService.saveUserRoles(response.data.roles);
			if(response.data.contragenrId) {
				TokenService.setContragentId(response.data.contragenrId)
			}else {
				TokenService.removeContrAgentId()
			}
			if (response.data.roles.includes('KASSIR')) {
				TokenService.setIsCashier(true);
			} else {
				TokenService.removeIsCashier();
			}
			if (response.data.roles.includes('MONITORING')) {
				TokenService.setIsMonitoring(true);
			} else {
				TokenService.removeIsMonitoring();
			}
			if (response.data.roles.includes('MANAGER')) {
				TokenService.setIsManager(true);
			} else {
				TokenService.removeIsManager();
			}
			if (response.data.roles.includes('admin')) {
				TokenService.setIsAdmin(true);
			} else {
				TokenService.removeIsAdmin();
			}
			if (response.data.roles.includes('Contragent')) {
				TokenService.removeDepSaleType()
				TokenService.setIsContragent(true);
			} else {
				TokenService.removeIsContragent();
			}
			ApiService.setHeader();
			ApiService.mount401Interceptor();
			return response.data;
		} catch (error) {
			throw new AuthenticationError(error.response.status, error.response.data.detail);
		}

	},

	/**
	 * Logout the current user by removing the token from storage.
	 *
	 * Will also remove `Authorization Bearer <token>` header from future requests.
	 **/
	logout() {
		// Remove the token and remove Authorization header from Api Service as well
		TokenService.removeToken();
		TokenService.removeCurrentUserId();

		TokenService.removeUserRoles()

		TokenService.removeDepCurrencyId();
		TokenService.removeDepCurrencyCode();
		TokenService.removeDepCurrencyName();
		TokenService.removeDepartmentId();
		ApiService.removeHeader();

		ApiService.unmount401Interceptor()
	}
};

export { UserService, AuthenticationError };
